/** Format a versionName for UI — show the marketing string as-is. */
export function toAppDisplayVersion(value: string): string {
	return value.trim();
}

export type AppUpdateDisplayInput = {
	platform: string;
	currentVersionName?: string;
	availableVersionName?: string;
	currentVersionCode?: string;
	availableVersionCode?: string;
};

export type AppUpdateDisplayResult = {
	isUpdateAvailable: boolean;
	currentDisplay?: string;
	availableDisplay?: string;
};

/**
 * Resolve whether an update is available and which version labels to show.
 * Display uses versionName only — never versionCode (Android build numbers are not user-facing).
 */
export function resolveAppUpdateDisplayVersions(
	input: AppUpdateDisplayInput,
): AppUpdateDisplayResult {
	const {
		platform,
		currentVersionName,
		availableVersionName,
		currentVersionCode,
		availableVersionCode,
	} = input;

	const isUpdateAvailable =
		platform === 'android'
			? Boolean(availableVersionCode && currentVersionCode !== availableVersionCode)
			: Boolean(availableVersionName && currentVersionName !== availableVersionName);

	if (!isUpdateAvailable) {
		return { isUpdateAvailable: false };
	}

	const currentDisplay = currentVersionName
		? toAppDisplayVersion(currentVersionName)
		: undefined;
	const availableDisplay = availableVersionName
		? toAppDisplayVersion(availableVersionName)
		: undefined;

	return {
		isUpdateAvailable: true,
		currentDisplay,
		availableDisplay,
	};
}
